<template>
  <svg width="18"
       height="18"
       viewBox="0 0 18 18"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M1.50293 7.55566C2.05664 7.55566 2.46973 7.15137 2.46973 6.58887V5.96484L2.28516 3.24023L4.31543 5.37598L6.8291 7.90723C7.01367 8.10059 7.25098 8.18848 7.50586 8.18848C8.10352 8.18848 8.53418 7.78418 8.53418 7.18652C8.53418 6.91406 8.42871 6.67676 8.24414 6.4834L5.72168 3.96094L3.57715 1.93945L6.31934 2.12402H7.00488C7.55859 2.12402 7.98047 1.71973 7.98047 1.15723C7.98047 0.594727 7.56738 0.181641 7.00488 0.181641H2.12695C1.11621 0.181641 0.527344 0.770508 0.527344 1.78125V6.58887C0.527344 7.14258 0.94043 7.55566 1.50293 7.55566ZM10.9863 17.1357H15.8643C16.875 17.1357 17.4639 16.5469 17.4639 15.5361V10.7285C17.4639 10.1748 17.042 9.76172 16.4883 9.76172C15.9346 9.76172 15.5215 10.166 15.5215 10.7285V11.3525L15.7061 14.0771L13.6758 11.9414L11.1621 9.41016C10.9775 9.2168 10.7402 9.12891 10.4766 9.12891C9.87891 9.12891 9.44824 9.5332 9.44824 10.1309C9.44824 10.4033 9.55371 10.6494 9.74707 10.834L12.2695 13.3564L14.4141 15.3779L11.6719 15.1934H10.9863C10.4238 15.1934 10.0107 15.5977 10.0107 16.1602C10.0107 16.7227 10.4238 17.1357 10.9863 17.1357Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'ExpandIcon',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>

<style>

</style>
